import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {isBrowser, isMobile} from 'react-device-detect';
import {ActionType, ActionGroupType, ActionTypeDefault} from './CoreProductEnum';
import EpiContext from '@episerver/spa-core/Spa';

export const getCustomerCoreProducts = createAsyncThunk('coreProductsOfCostumer/getCustomerCoreProducts', async (result) => {
  try {
    return result;
  } catch (error) {
    return [
      ActionType.CELLULAR,
      ActionType.INTERNET,
      ActionType.MAPA,
      ActionType.TV,
      ActionType.BUNDLE,
      ActionType.ERROR,
      ActionType.INVOICES,
    ];
  }
});

const toLowerArray = (array) => {
  if (!array) return null;
  const isArray = Array.isArray(array);
  if (!isArray) {
    array = [array];
  }
  return array.map((item, index) => {
    return item.toLowerCase();
  });
};

const onlyPrivateOrBusiness=(actionTypes)=>{
  let isOnlyPrivateOrBusiness=true;

  for (var i = 0; isOnlyPrivateOrBusiness && i < actionTypes.length; i++) {
    isOnlyPrivateOrBusiness = actionTypes[i]==='private' || actionTypes[i]==='business';
  }
  return isOnlyPrivateOrBusiness;
}

const checkIfPrivateOrBusiness=(actionTypes,customerType)=>{
  
  const isPrivate=customerType?.isPrivate;
  const isBusiness=customerType?.isBusiness;
  const isPrivateChecked=actionTypes.includes('private');
  const isBusinessChecked=actionTypes.includes('business');

  if(isPrivateChecked && isBusinessChecked){
    return isPrivate || isBusiness;
  }
  else if(!isPrivateChecked && isBusinessChecked){
    return isBusiness;
  }
  else if(isPrivateChecked && !isBusinessChecked){
    return isPrivate;
  }
    return false;
}

const isExistActionType = (coreProductsTypes, actionTypes,customerType) => {
  
  if (!actionTypes) {
    return false;
  }

  const isPrivateOrBusiness = checkIfPrivateOrBusiness(actionTypes,customerType);
  if (!isPrivateOrBusiness) {
    return false;
  }
  if(onlyPrivateOrBusiness(actionTypes)){
    return true;
  }
  let isExist = false;
  coreProductsTypes=coreProductsTypes.filter(i=>(i!=='private' && i!=='business'))
  for (var i = 0; !isExist && i < actionTypes.length; i++) {
    isExist = coreProductsTypes.indexOf(actionTypes[i].toString()) !== -1;
  }
  return isExist;
};

export const getActionsByTypes = async (types, actionGroupType) => {
  const store = await EpiContext.getStore();
  const state = store.getState();
  let actions = [];

  if (types == null) {
    types = ActionTypeDefault;
  }

  switch (actionGroupType) {
    case ActionGroupType.ACTIONS:
      actions = state.coreProductActions.actions;
      break;

    case ActionGroupType.ACTIONSCOMMONTROUBLESHOOTING:
      actions = state.coreProductActions.actionsCommonTroubleShooting;
      break;

    case ActionGroupType.ALL:
      actions = state.coreProductActions.actions;
      actions = actions.concat(state.coreProductActions.actionsCommonTroubleShooting);
      break;
  }

  let results = getCoreProductActions(types, actions,state.welcomeBlock?.customerType);
  return results;
};

const getCoreProductActions = (coreProductsTypes, coreProductActions,customerType) => {
  let actions = [];
  coreProductActions.map((item, index) => {
    let isExist = isExistActionType(toLowerArray(coreProductsTypes), toLowerArray(item.actionServices),customerType);
    if (isExist) {
      actions.push(item);
    }
  });
  return actions;
};

export const mappingEpiData = (data) => {
  let mapped = [];
  if (data)
    try {
      mapped = data.map((item, index) => {
        let moreThanOneService = item.actionServices?.value.indexOf(',') != -1;
        let actionServicesArray = '';
        if (moreThanOneService) {
          actionServicesArray = item.actionServices?.value.split(',');
        } else {
          actionServicesArray = item.actionServices?.value;
        }
        return {
          actionServices: actionServicesArray,
          actionName: item.actionName?.value,
          iconUrl: item.actionIcon?.expandedValue?.url,
          actionUrl: item.actionUrl?.value,
          isNew: item.isNew?.value != null ? item.isNew?.value : false,
          actionId: item.contentLink?.id,
        };
      });
    } catch (e) {
      console.log(e);
    }
  return mapped;
};

const coreProductActionsSlice = createSlice({
  name: 'coreProductActions',
  initialState: {
    coreProductsTypes: [],
    actions: [],
    actionsCommonTroubleShooting: [],

    isLoading: false,
    isActionsLoaded: false,
    isActionsReady: false,
    tabs: [],
    selectedTab: {},
    showAllItems: false,
    isCustomerInitLoaded: false,
  },
  reducers: {
    setIsCustomerInitLoaded: (state, action) => {
      state.isCustomerInitLoaded = action.payload;
    },
    pushCoreProductActions: (state, action) => {
      let actions = [];
      let actionsCommonTroubleShooting = [];

      let coreProductTroubleShooting = action.payload.coreProductCommonTroubleShootingArea;
      let coreProductActions = action.payload.coreProductActions;
      let coreProductsTypes = action.payload.coreProductsTypes;
      let customerType = action.payload.customerType;

      actions = getCoreProductActions(coreProductsTypes, coreProductActions,customerType);
      actionsCommonTroubleShooting = getCoreProductActions(coreProductsTypes, coreProductTroubleShooting,customerType);

      if (actions.length > 0) {
        state.actions = actions;
      }
      if (actionsCommonTroubleShooting.length > 0) {
        state.actionsCommonTroubleShooting = actionsCommonTroubleShooting;
      }

      state.isActionsReady = true;
    },
    setTabs: (state, action) => {
      state.tabs = action.payload;
      state.selectedTab = action.payload[0];
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setShowAllItems: (state, action) => {
      state.showAllItems = action.payload;
    },
  },
  extraReducers: {
    [getCustomerCoreProducts.fulfilled]: (state, action) => {
      let coreProductsTypes = [];
      if ((Array.isArray(action.payload) && action.payload.length === 0) || action.payload === null || !Array.isArray(action.payload)) {
        coreProductsTypes = [ActionType.INVOICES, ActionType.NOPRODUCTS];
      } else {
        coreProductsTypes = action.payload.map((item, index) => {
          return item;
        });
        coreProductsTypes.push(ActionType.INVOICES);
      }
      return {
        ...state,
        coreProductsTypes: coreProductsTypes,
        isLoading: false,
        isActionsLoaded: true,
      };
    },
  },
});

export const {pushCoreProductActions, setTabs, setSelectedTab, setShowAllItems, setIsCustomerInitLoaded, setItemToActionType} =
  coreProductActionsSlice.actions;

export default coreProductActionsSlice.reducer;
